import { useState } from 'react';

import { Button } from '@/components/Button';

import s from './TotpEnroll.module.scss';

type RecoveryCodesProps = {
  codes: string[];
  /** Fired once the user acknowledges they've saved the codes. */
  onDone: () => void;
};

/**
 * Recovery codes are returned exactly once — on the account's first confirmed 2FA
 * method — and the API has no way to fetch them again. This is the only chance to
 * save them, so the screen is shared by every confirm flow (TOTP, email, SMS).
 */
const RecoveryCodes = ({ codes, onDone }: RecoveryCodesProps) => {
  const [copied, setCopied] = useState(false);

  const copyAll = () => {
    navigator.clipboard.writeText(codes.join('\n'));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={s.body}>
      <div className={s.heading}>
        <h2 className={s.title}>Save Recovery Codes</h2>
      </div>
      <div className={s.warningNotice}>
        <span className={s.warningIcon}>⚠</span>
        <p>
          Each code signs you in <strong>once</strong> if you lose access to your two-factor method.
          Please store them somewhere safe, as you won’t see them again.
        </p>
      </div>
      <div className={s.codeBox}>
        <ul className={s.recoveryList}>
          {codes.map((c) => (
            <li key={c} className={s.codeItem}>
              {c}
            </li>
          ))}
        </ul>
      </div>
      <button className={s.copyBtn} onClick={copyAll} type="button">
        {copied ? '✓ Copied!' : 'Copy All Codes'}
      </button>
      <Button className={s.submit} onClick={onDone}>
        I&apos;ve saved them
      </Button>
    </div>
  );
};

export default RecoveryCodes;
